import { logger } from '@heidi/runtime/logger';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { GET_INITIAL_PINNED_TEMPLATES } from '../../contracts';
import { getInitialPinnedTemplates } from '../api/templates';
import { getTemplatesDataConfig } from '../config';

/**
 * Module-scope invalidator — runs outside a hook, so it takes the app's
 * queryClient singleton from the `configureTemplatesData` seam.
 */
export const invalidateInitialPinnedTemplates = () =>
  getTemplatesDataConfig().queryClient.invalidateQueries({
    queryKey: [GET_INITIAL_PINNED_TEMPLATES],
  });

/** `isAuthenticated` is the app's `state.auth.token` read, composed app-side (cohort-C). */
export function useQueryInitialPinnedTemplates(
  options?: { enabled?: boolean },
  isAuthenticated = true
) {
  return useQuery({
    enabled:
      options?.enabled !== undefined
        ? options.enabled && isAuthenticated
        : isAuthenticated,
    queryKey: [GET_INITIAL_PINNED_TEMPLATES],
    queryFn: async () => {
      try {
        const { data } = await getInitialPinnedTemplates();
        return data.templates;
      } catch (error) {
        if (error instanceof AxiosError) {
          logger.error(error.message);
        }
      }
    },
  });
}
